export default __webpack_public_path__ + "static/media/modal-figure.ac71dcc3.svg";